import * as S from "./InputTextarea.style";
import { ChangeEvent } from "react";
import { InputProps, Inputs } from "..";

interface InputTextareaProps extends InputProps {
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const InputTextarea = (props: InputTextareaProps) => {
  return (
    <Inputs label={props.label ? props.label : undefined}>
      <S.InputTextarea
        placeholder={props.placeholder}
        onChange={props.onChange}
      />
    </Inputs>
  );
};
